import { apiRequest } from '@/lib/queryClient';
import {
  buildComposerMentionQuery,
  composerMentionQueryMatchesTitle,
  MARTINA_COMPOSER_MENTION_ENTITY_TYPES,
  type MartinaComposerCrmHit,
} from '@/components/exai/martinaComposerMentionContract';

/** Ricerca anagrafica condivisa: drawer Martina e composer Feed. */
export async function fetchComposerMentionHits(search: string): Promise<MartinaComposerCrmHit[]> {
  const pages = await Promise.all(MARTINA_COMPOSER_MENTION_ENTITY_TYPES.map(async (entityType) => {
    // La ricerca usa POST per il payload strutturato, ma e' una lettura:
    // non deve attivare il toast globale "Creazione completata" a ogni
    // carattere digitato nel composer.
    const data = await apiRequest({
      url: '/api/crm-query/execute',
      method: 'POST',
      data: buildComposerMentionQuery(entityType, search),
      isMutation: false,
      notifySuccess: false,
    });
    return ((data?.items ?? []) as Array<{ id: string; title: string; subtitle?: string; href?: string }>).map((item) => ({
      type: entityType,
      id: String(item.id),
      title: item.title,
      subtitle: typeof item.subtitle === 'string' && item.subtitle.trim() ? item.subtitle.trim() : undefined,
      href: item.href,
    }));
  }));
  const seen = new Set<string>();
  return pages.flat().filter((hit) => {
    const key = `${hit.type}:${hit.id}`;
    if (seen.has(key) || !composerMentionQueryMatchesTitle(search, hit.title)) return false;
    seen.add(key);
    return true;
  });
}
